import type { CalculatorMeta } from '../../types/calculator';

const meta: CalculatorMeta = {
  route: '/sales-tax',
  component: () => import('../../routes/SalesTax.svelte'),
  card: {
    id: 'sales-tax',
    title: 'Sales Tax',
    description: 'Calculate sales tax, before/after tax prices, and compare state tax rates.',
    icon: 'receipt_long',
    iconBgClass: 'bg-blue-50',
    iconTextClass: 'text-primary',
    href: '/sales-tax',
    category: 'Retirement & Tax',
  },
  seo: {
    title: 'Sales Tax Calculator – Calculate Tax, Before & After Tax Prices',
    description: 'Free sales tax calculator to find tax amount, before-tax price, or tax rate. Includes US state sales tax rates. Calculate unit and total prices with quantity support.',
  },
};

export default meta;
